import { render, staticRenderFns } from "./SubItemCategory.vue?vue&type=template&id=9b331e56"
import script from "./SubItemCategory.vue?vue&type=script&lang=js"
export * from "./SubItemCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports